import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { usePaginatedList } from "@hooks/usePaginatedList";
import GroupItem from "../UsersGroups/components/GroupItem";
import { useUsersGroupsActions } from "../UsersGroups/hooks/useUsersGroupsActions";
import { buildUGListUrl, UGTabKey } from "../UsersGroups/types";
import PanelList from "./PanelList";

const PAGE_SIZE = 5;

interface GroupsPanelProps {
  tab: Extract<UGTabKey, "static-groups" | "dynamic-groups">;
}

export default function GroupsPanel({ tab }: GroupsPanelProps) {
  const { id: corporateId = "" } = useParams();
  const isStatic = tab === "static-groups";

  const listUrl = useMemo(
    () => buildUGListUrl(tab, corporateId),
    [tab, corporateId],
  );

  const filters = useMemo(
    () => ({ page: 1, pageSize: PAGE_SIZE, sort: "most-recent" }),
    [],
  );

  const { items, isLoading, mutate } = usePaginatedList(listUrl, filters);

  const { getGroupActions, modals } = useUsersGroupsActions({
    corporateId,
    onRefresh: () => mutate && mutate(),
  });

  const groupActions = getGroupActions(isStatic ? "STATIC" : "DYNAMIC");

  return (
    <>
      <PanelList isLoading={isLoading} isEmpty={items.length === 0}>
        {items.map((group: any) => (
          <GroupItem
            key={`group-${group.id}`}
            group={group}
            entityType={isStatic ? "group-static" : "group-dynamic"}
            corporateId={corporateId}
            selectable={false}
            showCreationDate
            {...groupActions}
          />
        ))}
      </PanelList>
      {modals}
    </>
  );
}
